import { CHANGE_PAGINA } from '../actions/types';

const INITIAL_STATE = 1;

/* eslint-disable import/no-anonymous-default-export */
export default function(state = INITIAL_STATE, action) {
  switch(action.type) {
    case CHANGE_PAGINA: {
      return action.payload;
    }
    default: {
      return state;
    }
  }
}
